import type { CalibrationRuntimeData } from '@/features/calibration/hooks/useCalibrationRuntime/types';

export type TestTypeResult = {
  hasData: boolean;
  asFoundPassed: boolean;
  asLeftPassed: boolean;
  totalPoints: number;
  completedPoints: number;
};

export type OverallResults = {
  asFoundPassed: boolean;
  asLeftPassed: boolean;
  completedPoints: number;
  totalPoints: number;
};

const EMPTY_RESULT: TestTypeResult = {
  hasData: false,
  asFoundPassed: true,
  asLeftPassed: true,
  totalPoints: 0,
  completedPoints: 0
};

const calculateBasicReadingResults = (
  calibrationData: CalibrationRuntimeData
): TestTypeResult => {
  const testPoints = calibrationData.tests?.basicReading?.testPoints;
  if (!testPoints?.length) return EMPTY_RESULT;

  const completedPoints = testPoints.filter(
    p => p.asFound !== null || p.asLeft !== null
  ).length;

  const asFoundPassed = testPoints
    .filter(p => p.asFound !== null)
    .every(p => p.asFoundResult === 'Pass');

  const asLeftPassed = testPoints
    .filter(p => p.asLeft !== null)
    .every(p => p.asLeftResult === 'Pass');

  return {
    hasData: true,
    asFoundPassed,
    asLeftPassed,
    totalPoints: testPoints.length,
    completedPoints
  };
};

export const calculateOverallResults = (
  calibrationData: CalibrationRuntimeData | null
): OverallResults => {
  if (!calibrationData) {
    return {
      asFoundPassed: true,
      asLeftPassed: true,
      completedPoints: 0,
      totalPoints: 0
    };
  }

  const result = calculateBasicReadingResults(calibrationData);

  if (!result.hasData) {
    return {
      asFoundPassed: true,
      asLeftPassed: true,
      completedPoints: 0,
      totalPoints: 0
    };
  }

  return {
    asFoundPassed: result.asFoundPassed,
    asLeftPassed: result.asLeftPassed,
    totalPoints: result.totalPoints,
    completedPoints: result.completedPoints
  };
};
